import type { EventQuery, EventQueryEvent } from "~/components/layout/Search/Search.vue";
import type { IOfferQuery } from "~/types/graph-ql/graphql-types";
import type { ISport } from "~/types/sports/sport";

const extractMarketsAndEventIds = (offers: IOfferQuery | EventQuery, sports: ISport[] | undefined) => {
	let markets: { name: string; displayName: string; filterIndex: number }[] = [];
	const sportIds: string[] = [];
	const eventIds: string[] = [];
	if ("matchTable" in offers && offers?.matchTable.eventRefs) {
		offers.matchTable.eventRefs.forEach((eventRef) => {
			if (!eventIds.includes(eventRef.id)) eventIds.push(eventRef.id);
			if (!sportIds.includes(eventRef.catalog.group.subCategory.category.id)) sportIds.push(eventRef.catalog.group.subCategory.category.id);
		});
	}

	if ("events" in offers && offers?.events.length > 0) {
		for (const event of offers.events) {
			if (event.markets.length > 0) {
				eventIds.push(event.eventId.toString());
				if (!sportIds.includes(event.sport)) {
					sportIds.push(event.sport);
				}
			}
		}
	}

	sportIds.forEach((id) => {
		const sport = sports?.find((sport) => sport.sportId === id || sport.name === id);
		if (sport?.defaultMarkets) {
			markets = [...markets, ...sport.filterMarkets];
		}
	});

	return {
		markets,
		eventIds,
	};
};

export { extractMarketsAndEventIds };
